import { render, staticRenderFns } from "./cricketpanel.vue?vue&type=template&id=06e77a0e&"
import script from "./cricketpanel.vue?vue&type=script&lang=js&"
export * from "./cricketpanel.vue?vue&type=script&lang=js&"
import style0 from "./cricketpanel.vue?vue&type=style&index=0&id=06e77a0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports